import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Grid,
  Box,
} from '@mui/material';
import PropTypes from 'prop-types';
import RigPhotoCard from '../../../checkInsDrill/rigPhotosModal/rigPhotoCard';
import Premium from '../../../../assets/images/PRO logo PMS green only.svg';
import { CancelPresentationRounded } from '@mui/icons-material';

const ClusterPhotosGallery = ({ open, onClose, data, type }) => {
  return (
        <Dialog fullScreen open={open} onClose={onClose}>
            <AppBar elevation={0} position="sticky">
                <Toolbar
                    sx={{
                      background: 'linear-gradient(to right, #ffffff, #cacaca)',
                      color: '#000'
                    }}
                >
                    <Box
                        component="img"
                        alt="Logo"
                        src={Premium}
                        sx={{ m: 2, height: '65px' }}
                    />
                    <Typography sx={{ flex: 1 }} variant="h5">
                        {type} Field Pictures
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CancelPresentationRounded fontSize='large' />
                    </IconButton>
                </Toolbar>
            </AppBar>

            <Grid container spacing={2} sx={{ p: 2 }}>
                {data.map((item, idx) => (
                    <Grid item xs={12} sm={6} md={4} key={idx}>
                        <RigPhotoCard
                            avatarLetter={item.sRig.charAt(0)}
                            comment={item.comment}
                            title={`${item.sRig}`}
                            image={item.picture}
                            email={item?.userEmail}
                            imageHeight={'350px'}
                            lastUpdate={item?.lastUpdate}
                        />
                    </Grid>
                ))}
            </Grid>
        </Dialog>
  );
};

ClusterPhotosGallery.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  type: PropTypes.string
};

export default ClusterPhotosGallery;
